import styles from './PeliculaDetails.module.css'
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { get } from "../utils/httpClient";
import { Spinner } from '../components/Spinner';
import { getMovieImg } from '../utils/getMovieImg';
import { Link } from 'react-router-dom';

export function PeliculaDetails() {
    const { peliculaId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [pelicula, setPelicula] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        get("/movie/" + peliculaId).then((data) => {
            setPelicula(data);
            setIsLoading(false);
        });
        get("/movie/" + peliculaId + "/credits").then((data) => {
            console.log(data);
        });
    }, [peliculaId]);

    if (isLoading) {
        return <Spinner />;
    }

    // Guard: la API devolvió null o datos inválidos
    if (!pelicula || !pelicula.poster_path) {
        return (
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <p>No se encontraron datos para esta película.</p>
                <Link to="/">← Volver al catálogo</Link>
            </div>
        );
    }

    const imageUrl = getMovieImg(pelicula.poster_path, 500);

    return (
        <div>
            <div style={{ padding: '10px 40px' }}>
                <Link to="/">← Volver al catálogo</Link>
            </div>
            <div className={styles.detailsContainer}>
                <img
                    className={`${styles.col} ${styles.peliculaImage}`}
                    src={imageUrl}
                    alt={pelicula.title}
                />
                <div className={`${styles.col} ${styles.PeliculaDetails}`}>
                    <p><strong>Título:</strong> {pelicula.title}</p>
                    <p>
                        <strong>Género: </strong>
                        {pelicula.genres?.map(genre => genre.name).join(", ")}
                    </p>
                    <p><strong>Descripción:</strong> {pelicula.overview}</p>
                </div>
            </div>
        </div>
    );
}